module.exports = __webpack_public_path__ + "static/media/header_image_1.16cc1854.webp";